module.exports = __webpack_public_path__ + "static/media/ua.9b21c6a4.png";